export default {
  leftPanel: {
    title: "为何要加入我们？",
    paragraph1: "我们在全球范围内寻找顶尖精英人才。",
    paragraph2:
      "只要你敢想敢做，超导就是你实现梦想的舞台，在这里你可以尽情彰显个性，释放激情。",
    paragraph3: "只要你是牛人，只要你对梦想有所执着，超导就是你的归属。",
    paragraph4: "邮箱（招聘）：hr{'@'}shsctec.com",
  },

  jobs: {
    salesSpecialist: {
      title: "销售工程师",
      details: `岗位职责： 
 ---1、深度解读行业政策与市场趋势，精准匹配客户需求与公司核心优势，协同（跨）部门团队优化标书核心内容，打造具有市场竞争力的投标方案。 
 ---2、聚焦行业内重点客户机潜在战略合作伙伴，建立并维护深层次、长期稳定的合作关系。 
 ---3、快速响应客户在技术、产品及服务方面的个性化需求，高效处理各类紧急情况，以专业服务显著提升客户满意度与忠诚度，助力公司构建优质客户生态圈。 
 ---4、独立掌控销售全流程，包括前期客户接洽、需求分析、方案制定，到中期商务谈判、合同签订，再到后期订单执行跟踪，确保每个环节高效推进。 
 ---5、基于对超导行业及相关应用领域的深入研究，制定前瞻性的客户开发战略与计划；通过参与行业展会、开展精准市场调研等多种渠道，积极挖掘潜在战略客户。 
 ---6、主动拜访潜在客户，深入了解其技术需求与业务规划，精准推荐公司二代高温超导带材的技术优势与应用价值，促成高质量合作意向。 
 ---任职要求： 
 ---1、本科及以上学历，材料学、物理学等相关专业优先。 
 ---2、具备二代高温超导带材及相关领域知识者优先。 
 ---3、具备出色的沟通技巧与高端商务谈判能力，能有效与各类客户进行深度交流并达成合作。 
 ---4、拥有优秀的问题解决能力，能独立应对销售过程中的各种复杂情况。对销售工作充满热情，积极主动，具有强烈的目标感与执行力。 
 ---5、具备战略眼光与高度，能从公司长远发展角度思考问题，有清晰的市场洞察力与前瞻性，能为公司销售战略与市场布局提供有价值的想法与建议。 
 ---6、具备良好的团队协作精神，能与部门负责人及其他团队成员紧密配合，共同完成公司销售目标。`,
      },
    opticalEngineer: {
      title: "光学技术工程师",
      details: `岗位职责：
---1.负责对部门内工艺的研发测试及优化改进，特别是激光加工工艺开发与优化。
---2.负责对生产异常参数汇总与归纳总结，并提出优化解决方案。
---3.建立并完善激光加工工艺数据库，跟踪先进激光加工技术与工艺趋势，引入新技术、新工艺进行测试与应用，推动部门工艺水平提升。
---4.参与负责激光加工相关项目的推进，负责项目中工艺环节的执行与管控，跟进项目进度，协调解决项目中的工艺技术问题。
---5.深入生产现场，监督后处理工序工艺执行情况，及时发现并解决生产过程中的工艺异常问题，为生产操作人员提供技术指导与支持。
---6.协助完成新设备的安装调试与工艺验证工作，确保设备满足后处理工艺要求，快速实现量产转化。
---7.协助进行专利或项目的申报工作。
---任职要求：
---1.具有激光加工工艺相关工作经验者优先，具有光学类专业背景者优先。
---2.具备良好的实验设计与数据分析能力，能够独立开展工艺实验，分析实验数据并撰写专业的实验报告。
---3.掌握激光加工工艺缺陷分析方法，能够快速定位并解决加工过程中出现的工艺质量问题。
---4.熟悉激光器及激光加工设备的工作原理，掌握光路调试及优化技能。
---5.具备良好的沟通协调能力，能够与研发、生产、销售、客户等多方进行有效沟通协作。
---6.工作严谨细致，责任心强，具备较强的问题解决能力与抗压能力，能够适应项目紧急时的加班需求。`,
    },
    testEngineer: {
      title: "测试工程师（研发岗）",
      details: `岗位职责：
---1.负责对超导带材，超导线圈、超导接头进行综合性能测试分析；
---2.对材料进行性能测试和分析，以确保材料能够满足工业应用的需求；
---3.跟踪调研各科研单位及企业对材料的应用情况；
---4.熟练掌握负责各检测设备和表征设备的操作；
---5.负责高温超导材料性能表征与优化；
---任职资格
---1.物理、化学、材料、电气等相关专业，电气优先；
---2.动手能力强，有超导材料相关工作经验者优先考虑 ；
---3.具有较强的观察能力和分析能力，熟悉各类测试设备和数据处理软件；
---4.工作认真负责、严谨细致、有良好的团队意识和沟通能力。`,
    },
    rdEngineer: {
      title: "研发工程师（研发岗）",
      details: `岗位职责：
---1.根据研发部门的研发计划，设计和落实具体实验方案；
---2.负责真空镀膜生产线（洁净车间）的制程异常分析，提出并落实解决方案；
---3.负责研发新制程工艺与新材料，提升超导带材产品的性能与良率；
---4.协助部门同事共同推进相关研发工作；
---5.完成领导安排的其他研发工作。
---任职资格：
---1.硕士及以上学历，材料类、物理类等相关专业优先；
---2.具有超导材料研究、薄膜材料制备或真空镀膜相关经验者优先；
---3.长期稳定，热爱研发工作，能按照部门的研发计划开展研发工作；
---4.工作认真负责，有进取精神，具备良好的职业素养和敬业精神。`,
    },
  },
}; 